(function () {
  const initFiltersToggle = (root) => {
    const toggle = root.querySelector('[data-filters-toggle]');
    const panel = root.querySelector('[data-filters-panel]');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', () => {
      const open = panel.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  };

  document.querySelectorAll('.col').forEach(initFiltersToggle);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target?.querySelector?.('.col');
    if (section) initFiltersToggle(section);
  });
})();
